module.exports = __webpack_public_path__ + "img/1.8e719c66.jpg";